import { FC, useMemo } from 'react'
import { CellProps } from 'react-table'
import {
  Button,
  CustomTable,
  InfoAlert,
  PlainHeader,
  StackedCell,
  StatusDot,
  TableColumn,
  useModal,
} from 'app/components'
import { ButtonType } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { EsusPendenciaDto } from '../../core/_esusModels'

type Props = {
  pendencias: EsusPendenciaDto[]
  onClose?: () => void
}

export const EsusChecklistModal: FC<Props> = ({ pendencias, onClose }) => {
  const { t } = useT()
  const { closeModal } = useModal()

  const handleClose = () => {
    if (onClose) {
      onClose()
    } else {
      closeModal()
    }
  }

  const columns: ReadonlyArray<TableColumn<EsusPendenciaDto>> = useMemo(
    () => [
      {
        Header: () => <PlainHeader>Local / Módulo</PlainHeader>,
        id: 'local',
        cellWidth: '180px',
        Cell: ({ row }: CellProps<EsusPendenciaDto>) => (
          <StackedCell primary={row.original.local || 'Geral'} />
        ),
      },
      {
        Header: () => <PlainHeader>Pendência identificada</PlainHeader>,
        id: 'mensagem',
        Cell: ({ row }: CellProps<EsusPendenciaDto>) =>
          row.original.campo ? (
            <StackedCell
              primary={row.original.mensagem}
              secondary={`Campo: ${row.original.campo}`}
            />
          ) : (
            <StackedCell primary={row.original.mensagem} />
          ),
      },
      {
        Header: () => <PlainHeader>Ação</PlainHeader>,
        id: 'acao',
        cellWidth: '140px',
        align: 'end',
        Cell: () => <StatusDot label='Obrigatório' tone='danger' />,
      },
    ],
    []
  )

  return (
    <div className='py-2'>
      <InfoAlert variant='warning' title='Integração e-SUS APS Bloqueada'>
        Existem pendências cadastrais que impedem a ativação da transmissão para o PEC e-SUS APS.
        Corrija os itens abaixo antes de tentar ativar novamente.
      </InfoAlert>

      <CustomTable<EsusPendenciaDto>
        id='kt_table_esus_checklist'
        ariaLabel='Pendências do e-SUS APS'
        data={pendencias}
        columns={columns}
        notPaginated
      />

      <div className='d-flex justify-content-end mt-4'>
        <Button
          type={ButtonType.Button}
          onClick={handleClose}
          className='btn-secondary'
          size='btn-sm'
        >
          {t('common.close', undefined, 'Fechar')}
        </Button>
      </div>
    </div>
  )
}
